import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer py-12 md:py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center">
                <span className="text-white font-bold text-xl">SM</span>
              </div>
              <div>
                <h3 className="font-bold text-lg text-white">Shah Market</h3>
                <p className="text-sm text-white/70">Your Neighborhood Store</p>
              </div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              Serving the Visalia community with everyday essentials, friendly service, and a welcoming atmosphere since day one.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-white mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/80 hover:text-white transition-colors" data-testid="footer-home-link">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/80 hover:text-white transition-colors" data-testid="footer-about-link">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-white/80 hover:text-white transition-colors" data-testid="footer-products-link">
                  Products & Services
                </Link>
              </li>
              <li>
                <Link to="/location" className="text-white/80 hover:text-white transition-colors" data-testid="footer-location-link">
                  Hours & Location
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-white transition-colors" data-testid="footer-contact-link">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-white mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#E07A5F] mt-0.5 flex-shrink-0" />
                <span className="text-white/80">14346 Avenue 384<br />Yettem, CA 93292</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-[#E07A5F] flex-shrink-0" />
                <a href="tel:5094057493" className="text-white/80 hover:text-white">(509) 405-7493</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-[#E07A5F] flex-shrink-0" />
                <a href="mailto:shahsmarket1@gmail.com" className="text-white/80 hover:text-white">shahsmarket1@gmail.com</a>
              </li>
            </ul>
          </div>

          {/* Store Hours */}
          <div>
            <h4 className="font-bold text-white mb-4 flex items-center gap-2">
              <Clock size={18} className="text-[#E07A5F]" />
              Store Hours
            </h4>
            <ul className="space-y-2 text-sm">
              <li className="flex justify-between text-white/80">
                <span>Every Day</span>
                <span>6AM - 10PM</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-sm">
            © {currentYear} Shah Market. All rights reserved.
          </p>
          <p className="text-white/60 text-sm">
            Your local convenience store in Yettem, CA
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
